import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IAccount } from '../../hub-lo.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';

@Component({
    selector: 'hub-lo-account-selector-step',
    templateUrl: 'account-selector-step.component.html',
    styleUrls: ['account-selector-step.component.scss'],
})
export class HubLoAccountSelectorStepComponent implements OnInit, OnChanges {
    @Input() public accounts: IAccount[] = [];
    @Input() public selectedAccountId: number | null = null;
    @Input() public disabled: boolean = false;
    @Input() public consentChecked: boolean = false;
    @Input() public origin: 'Home' | 'Dados bancários' = 'Home';

    @Output() public selectAccount = new EventEmitter<number>();
    @Output() public consentChange = new EventEmitter<boolean>();
    @Output() public stepButton = new EventEmitter<void>();

    public termsForm: FormGroup;
    
        constructor(
            private formBuilder: FormBuilder,
            private store: Store<AppState>,
        ) {
            this.termsForm = this.formBuilder.group({
                agree: [false, Validators.required]
            });
        }
    
        public ngOnInit(): void {
            this.syncConsentState();
    
            this.termsForm.get('agree')?.valueChanges
                .subscribe((checked: boolean | null) => {
                    this.consentChange.emit(!!checked);
                });
        }

    public onSelectAccount(accountId: number): void {
        this.selectAccount.emit(accountId);
    }

    public getAccountTypeLabel(accountType: number): string {
        switch (accountType) {
            case 1:
                return 'Conta corrente';
            case 2:
                return 'Conta poupança';
            default:
                return 'Conta';
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.consentChecked) {
            this.syncConsentState();
        }
    }

    private syncConsentState(): void {
        this.termsForm.get('agree').setValue(this.consentChecked, { emitEvent: false });
    }

    public isStepButtonDisabled(): boolean {
        return !this.consentChecked;
    }

      public onContinueClick(): void {
        if (this.accounts.length === 1) {
          this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: {
              type: ActionEventsEnum.ELEMENT_CLICKED,
              events: {
                'Product Area Origin': this.origin,
                Element: 'Botão autorizar',
                Step: 'Autorizar comunicação entre contas',
                Scenario: 'Possui mais de uma conta cadastrada',
                Status: 'Cliente Santander',
                'Time Responsável': 'Sky',
              },
            },
          });
        }
        this.stepButton.emit();
      }
}
